import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

export const TopCTA = () => {
  return (
    <div className="bg-primary/10 border-y border-primary/20 py-4">
      <div className="container px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-center">
          <p className="text-sm md:text-base font-medium">
            Ready to get more leads from your website?
          </p>
          <a href="#get-started">
            <Button size="sm" className="gap-2">
              <Phone className="h-4 w-4" />
              Get Started
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};
